import React from "react";
import Intro from "./Intro";
import GameSection from "./GameSection";
import WebSection from "./WebSection";
import Awards from "./Awards";
import "../style/Base.css";
import MySkills from "./MySkills";
import GameProjectPresentionDisplay from "./GameProjectPresentionDisplay";
import WebProjectDisplay from "./WebProjectDisplay";
import AboutMe from "./AboutMe";

const HomePage = () => {
  return (
    <div>
      <Intro />
      <GameSection />
      <GameProjectPresentionDisplay />

      <WebProjectDisplay />

      <Awards />
      <MySkills />
      <AboutMe />
    </div>
  );
};

export default HomePage;
